import { Component, Input } from '@angular/core';
import { CommonInfoService } from '../cart-process/common-info.service';
import { OfferLegalInfoList } from '../interfaces/cart-details.interface'

@Component({
  selector: 'price-component',
  templateUrl: './price.component.html',
})
export class PriceComponent {
  public priceEnding: string;
  public unit: string;
  public mantissa: string;
  public crossedUnit: string;
  public crossedMantissa: string;
  public showCrossedPrice: boolean;
  public separatedCurrencyTax: string = '+ VAT';
  public tooltipContent: string;

  private priceValue: any;
  private oldPriceValue: any;

  @Input() public currencySymbol: string;
  @Input() public separateCurrency: boolean;

  @Input() set price(price: number | string) {
    if (typeof price === 'string') price = Number(price);
    this.priceValue = price;

    this.updatePrice();
  }

  @Input() set oldPrice(price: number | string) {
    if (typeof price === 'string') price = Number(price);
    this.oldPriceValue = price;
    this.showCrossedPrice = this.oldPriceValue > 0.0 && this.oldPriceValue > this.priceValue;

    this.updatePrice();
  }

  @Input() set priceTooltip(priceTooltip: OfferLegalInfoList) {
    const enabledTooltips = false;
    this.tooltipContent = enabledTooltips ? priceTooltip?.tooltipInfo : undefined;
  }
  constructor(
    public commonInfoService: CommonInfoService
  ) {
  }

  private splitPrice(price: number) {
    let splittedValue = String(price).split('.');
    let mantissa = splittedValue[1];

    return {
      unit: splittedValue[0],
      mantissa: parseInt(mantissa) ? ',' + mantissa + (new Array(3 - String(mantissa).length)).join('0') : ',00'
    };
  }

  private updatePrice() {
    this.priceEnding = this.commonInfoService.priceEnding;
    let priceObject = this.splitPrice(this.priceValue);

    this.unit = priceObject.unit;
    this.mantissa = priceObject.mantissa;

    let crossedPriceObject = this.splitPrice(this.oldPriceValue);

    this.crossedUnit = crossedPriceObject.unit;
    this.crossedMantissa = crossedPriceObject.mantissa;
  }
}
